function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Tag(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.554 2a1.5 1.5 0 011.078.44l9.928 9.93a1.498 1.498 0 010 2.12l-7.07 7.07a1.498 1.498 0 01-2.12 0l-9.93-9.928A1.5 1.5 0 012 10.554l.08-6.99A1.5 1.5 0 013.564 2.08l6.99-.08zm.011 1l-6.99.08a.5.5 0 00-.495.495L3 10.565a.5.5 0 00.147.36l9.933 9.935a.503.503 0 00.71 0l7.07-7.07a.503.503 0 000-.71l-9.935-9.933a.5.5 0 00-.36-.147zM5.067 5.067a2.5 2.5 0 113.535 3.535 2.5 2.5 0 01-3.535-3.535zm.707.707a1.5 1.5 0 102.121 2.121 1.5 1.5 0 00-2.121-2.121z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Tag);
export default ForwardRef;